import React from 'react';

// Campaign item icon - Crossed Swords (custom SVG, FontAwesome doesn't have this)
export const CampaignItemIcon = ({ size = 14 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'block' }}
  >
    {/* Sword 1: bottom-left to top-right */}
    <line x1="4" y1="20" x2="20" y2="4" />
    <polyline points="20,4 20,9 15,9" />
    <line x1="4" y1="20" x2="7" y2="17" />
    <line x1="6" y1="21" x2="3" y2="18" />
    
    {/* Sword 2: bottom-right to top-left */}
    <line x1="20" y1="20" x2="4" y2="4" />
    <polyline points="4,4 4,9 9,9" />
    <line x1="20" y1="20" x2="17" y2="17" />
    <line x1="18" y1="21" x2="21" y2="18" />
  </svg>
);

// Template item icon - Crossed swords with lighter stroke (template/blueprint feel)
export const TemplateItemIcon = ({ size = 14 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    opacity="0.7"
    style={{ display: 'block' }}
  >
    {/* Sword 1: bottom-left to top-right */}
    <line x1="4" y1="20" x2="20" y2="4" />
    <polyline points="20,4 20,9 15,9" />
    <line x1="4" y1="20" x2="7" y2="17" />
    <line x1="6" y1="21" x2="3" y2="18" />
    
    {/* Sword 2: bottom-right to top-left */}
    <line x1="20" y1="20" x2="4" y2="4" />
    <polyline points="4,4 4,9 9,9" />
    <line x1="20" y1="20" x2="17" y2="17" />
    <line x1="18" y1="21" x2="21" y2="18" />
  </svg>
);
